import { DashCard } from "../../../../script/components/dash-board/dash-card/dash-card";
import { CommChart } from "../../../../script/components/chart/charts";
import { BarsSeri, CommArgs, CommAxis, SpinSeri } from "../../../../script/components/chart/charts-item";
import { fwUtil } from "../../../../script/util";

export function DashProdCard(props) {
    const { loading, data } = props;

    const tooltipTamplate = (arg) => {
        return {
            text: `${arg.argumentText} ${arg.seriesName}: ${fwUtil.conv.to.krLocales(arg.value)}`,
        };
    };

    return (
        <DashCard
            title={"제품별 계획/생산 현황"}
            addClass={'prod'}
            loading={loading}
        >
            <CommChart
                dataSource={data}
                tooltip={{ location: "edge", template: tooltipTamplate }}
            >
                {CommArgs({ field: "prod_mont", categories: ["01","02","03","04","05","06","07","08","09","10","11","12"] })}
                {CommAxis({ name: "qtys", caption: "수량(건)", position: "left", start: 0 })}
                {BarsSeri({ valueField: "plan_qtys", caption: "계획수량", color: "#A4F590", args: "plan_mont", axis: "qtys" })}
                {BarsSeri({ valueField: "work_qtys", caption: "생산수량", color: "#4EACFF", args: "plan_mont", axis: "qtys" })}  
                {BarsSeri({ valueField: "infe_qtys", caption: "불량수량", color: "#ff5d5d", args: "plan_mont", axis: "qtys" })}        
            </CommChart>
        </DashCard>
    )
}